/* eslint-disable jsx-a11y/alt-text */
import { useState } from "react";
import ButtonC from "./ButtonC";
import style from "./Card.module.css";

const Card = ({ img, title, technology, description, site, repo }) => {
  const [info, setInfo] = useState(false);

  const infoOn = () => {
    setInfo(true);
  };

  const infoOff = () => {
    setInfo(false);
  };

  return (
    <div onMouseLeave={infoOff} className={style.card}>
      <a onMouseEnter={infoOn} href={site}>
        <img src={img} alt="ERROR" />
      </a>

      {info === true && (
        <section>
          <h3>{title}</h3>
          <p>
            <strong>Tecnologia:</strong>
            {technology}
          </p>
          <p>{description}</p>
          <ButtonC text="Acesse o Repositório" link={repo} />
        </section>
      )}
    </div>
  );
};

export default Card;
